import api from "./api";

// GET /events?q=&category=&page=
export const getEvents = (params = {}) =>
  api.get("/events", { params }).then((res) => res.data);

// GET /events/{slug}
export const getEvent = (slug) =>
  api.get(`/events/${slug}`).then((res) => res.data);

// GET /categories
export const getCategories = () =>
  api.get("/categories").then((res) => res.data);
